/**
 * Pluralizes a string using proper English pluralization rules
 * not case sensitive,
 */
export const pluralizeString = (value: string): string => {
  if (!value) {
    return value;
  }

  const lowerValue = value.toLowerCase();

  if (
    lowerValue.endsWith('ch') ||
    lowerValue.endsWith('sh') ||
    lowerValue.endsWith('x') ||
    lowerValue.endsWith('s')
  ) {
    return `${value}es`;
  }

  if (lowerValue.endsWith('y') && value.length > 1) {
    const secondLastChar = lowerValue[lowerValue.length - 2];
    if (!['a', 'e', 'i', 'o', 'u'].includes(secondLastChar)) {
      return `${value.slice(0, -1)}ies`;
    }
  }

  return `${value}s`;
};
